module.exports = __webpack_public_path__ + "static/img/case_jiuzhou.a2bd74aa.png";